import React from "react";
import { Factory, HardHat, Building2, Cog } from "lucide-react";

const industries = [
  {
    icon: Factory,
    title: "Industrial & Manufacturing",
    body:
      "Process safety, HAZOP, MOC governance, HAZMAT handling and machinery-level risk control for production environments.",
  },
  {
    icon: HardHat,
    title: "Construction & Contractors",
    body:
      "Site-specific EHS plans, scaffold & electrical safety, PTW frameworks and contractor on-boarding for high-risk builds.",
  },
  {
    icon: Building2,
    title: "IT Campus & Corporate",
    body:
      "Multi-tenant campus governance, fire & life safety, emergency response and ESG reporting for Fortune-500 facilities.",
  },
  {
    icon: Cog,
    title: "Process-led Organisations",
    body:
      "Structured EHS governance, compliance readiness and safety-discipline systems for regulated, audited operations.",
  },
];

export default function Industries() {
  return (
    <section
      data-testid="industries"
      id="industries"
      className="bg-bgdark dark-section text-white border-t border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <p className="mono-label">Sectors served</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight mt-5 leading-[0.95]">
              Where the discipline
              <br />
              <span className="text-accent-amber">earns its keep</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-white/70 leading-relaxed">
              We work where the stakes are highest — multi-trade construction
              sites, live industrial floors, and global IT campuses with
              thousands of daily occupants and round-the-clock operations.
            </p>
          </div>
        </div>

        <div
          data-testid="industries-grid"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10"
        >
          {industries.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                data-testid={`industry-card-${i}`}
                className="border-r border-b border-white/10 p-8 group hover:bg-white/[0.04] transition-colors"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-mono text-xs text-white/40">
                    [{String(i + 1).padStart(2, "0")}]
                  </span>
                  <Icon size={22} strokeWidth={1.4} className="text-accent-amber" />
                </div>
                <h3 className="font-display text-xl uppercase leading-tight">
                  {it.title}
                </h3>
                <p className="mt-3 text-sm text-white/65 leading-relaxed">
                  {it.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
